import { Grid } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FilterTable from "../../components/table/FilterTable";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import { useChannels } from "../../services/channelsService";
import TableService from "../../services/tableService";
import {
    CHANNELS_TABLE_NAME,
    useChannelsTableFieldsConfig,
} from "./ChannelTableFieldsConfig";

export default function MarketingPanelChannelsPage(props) {
    const { hasAccess } = useAccessControl([USER_ROLES.SALES_MARKETING, USER_ROLES.ADMIN]);

    if (!hasAccess){
        return null
    }

    const { t } = useTranslation();
    const CHANNELS_TABLE_FIELDS_CONFIG = useChannelsTableFieldsConfig();

    const [dataLocal, setDataLocal] = useState([]);
    const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
    const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
    const [recordsCount, setRecordsCount] = useState(0);

    const {
        resetPageNumber,
        searchParams,
        setSearchParams,
        page: dataPage,
        pageSize: dataPageSize,
        handleChangePageWithSearchParams: handleChangeDataPage,
        handleChangePageSizeWithSearchParams: handleChangeDataPageSize,
    } = usePaginationWithSearchParams();

    const { data: channelsData, isLoading } = useChannels(searchParams);

    useEffect(() => {
        if (channelsData?.results) {
            setDataLocal(channelsData.results);
            setRecordsCount(channelsData.count);
        }
    }, [channelsData, dataPage, dataPageSize]);

    const onClickButton = useCallback((e, id) => {
        e.stopPropagation();
    }, []);

    const channelsDataExportHeaders = useMemo(() => {
        return TableService.getTableExportHeaders(
            CHANNELS_TABLE_FIELDS_CONFIG, // @ts-ignore
            hiddenColumnsForTables?.[CHANNELS_TABLE_NAME] || [], // @ts-ignore
            columnsOrdersForTables?.[CHANNELS_TABLE_NAME] || [],
        );
    }, [CHANNELS_TABLE_FIELDS_CONFIG, hiddenColumnsForTables, columnsOrdersForTables]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                CHANNELS_TABLE_FIELDS_CONFIG,
                dataLocal, // @ts-ignore
                hiddenColumnsForTables?.[CHANNELS_TABLE_NAME]
                    ? // @ts-ignore
                      hiddenColumnsForTables?.[CHANNELS_TABLE_NAME]
                    : [], // @ts-ignore
                columnsOrdersForTables?.[CHANNELS_TABLE_NAME]
                    ? // @ts-ignore
                      columnsOrdersForTables?.[CHANNELS_TABLE_NAME]
                    : [],
                onClickButton,
            ),
        [
            CHANNELS_TABLE_FIELDS_CONFIG,
            dataLocal,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            onClickButton,
        ],
    );

    const tableComponent = () => (
        <FilterTable
            // @ts-ignore
            data={data}
            countRecords={recordsCount}
            resetPageNumber={resetPageNumber}
            style={{ maxHeight: "60vh" }}
            headersConfig={TableService.orderColumns(
                TableService.hideHiddenColumns(
                    CHANNELS_TABLE_FIELDS_CONFIG, // @ts-ignore
                    hiddenColumnsForTables?.[CHANNELS_TABLE_NAME] || [],
                ),
                // @ts-ignore
                columnsOrdersForTables?.[CHANNELS_TABLE_NAME] || [],
            )}
            showCleanFilterIcon={true}
            showContextMenu={false}
            showExportToFileButton={true}
            exportToFileUrl={"customers/channels/export/"}
            exportToFileSearchParams={searchParams}
            exportToFileHeaders={channelsDataExportHeaders}
            exportToFileFileName={`${t("channels.exportFileName")}.xlsx`}
            showDetailsIcon={false}
            showCheckbox={false}
            page={dataPage}
            onPageChange={handleChangeDataPage}
            rowsPerPage={dataPageSize}
            onRowsPerPageChange={handleChangeDataPageSize}
            setDataLocal={setDataLocal}
            isLoading={isLoading}
        />
    );

    return (
        // @ts-ignore
        <DefaultPageWrapper tagTitle={t("headers.channels")}>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                rowSpacing={1}
            >
                <Grid item xs={12}>
                    <LoaderWrapper showLoader={false}>{tableComponent()}</LoaderWrapper>
                </Grid>
            </Grid>
        </DefaultPageWrapper>
    );
}
